import toggleVisibility from '../toggleVisibility';
import { ATTRIBUTES } from '../constants';

const updateSelectedVariant = ({ variant, variantInventory = [], elements = {}, strings = {} }) => {
  const {
    productPreOrderMsg,
    productSoldInfo,
    klaviyoBIS,
    atcButtonMsg,
    deliveryCountdown
  } = elements;

  // Strict booleans: variantInventory is empty unless the product is tagged
  // "preorder", and an undefined isPreOrder would reach toggleAttribute /
  // classList.toggle as a missing force argument, which toggles instead of
  // setting — the countdown flipped on every variant change.
  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = Boolean(current && !current.available && current.inventory_policy === 'continue');
  const isAvailable = Boolean(variant.available);
  const isSoldOut = !isAvailable && !isPreOrder;

  if (productPreOrderMsg) toggleVisibility(productPreOrderMsg, isPreOrder);
  if (productSoldInfo) toggleVisibility(productSoldInfo, !isPreOrder && isAvailable);
  if (klaviyoBIS) toggleVisibility(klaviyoBIS, isSoldOut);
  // A next-day promise makes no sense for a sold-out or pre-order variant. The
  // attribute blanks the block via its data-[variant-sold-out]:invisible class
  // (space kept, so switching variants does not shift the page), independently
  // of the countdown's own bank-holiday / no-message states.
  if (deliveryCountdown) deliveryCountdown.toggleAttribute(ATTRIBUTES.VARIANT_SOLD_OUT, !isAvailable || isPreOrder);

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    atcButtonMsg.textContent = getAtcBtnText();
  }
};

export default updateSelectedVariant;
